import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import CargoTypeModel from '../models/CargoTypeModel';
import CargoGroupModel from '../models/CargoGroupModel';

interface cargoTypeSelectorState {
    cargoTypes: CargoTypeModel[],
    cargoGroups: CargoGroupModel[]
}

export const initialState: cargoTypeSelectorState = {
    cargoTypes: [],
    cargoGroups: []
}

export const CargoTypeSelectorSlice = createSlice({
    name: "CargoTypeSelector",
    initialState,
    reducers: {
        setCargoTypes: (state, action: PayloadAction<CargoTypeModel[]>) => {
            state.cargoTypes = action.payload;
        },
        setCargoGroups: (state, action: PayloadAction<CargoGroupModel[]>) => {
            state.cargoGroups = action.payload;
        },
    }
});

export const cargoTypeSelectorSelector = createSelector(
    (state: RootState) => state.cargoType,
    (data) => data
);

export const {
    setCargoTypes,
    setCargoGroups,
} = CargoTypeSelectorSlice.actions;

export default CargoTypeSelectorSlice.reducer;